import React from 'react'

type CloseModalIconProps = {
  size: number | string
}

const CloseModalIcon = ({ size }: CloseModalIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 63 63"
  >
    <g fill="none" fillRule="evenodd" stroke="#FFF" transform="translate(3 3)">
      <circle
        cx="28.5"
        cy="28.5"
        r="30"
        fill="#006FE4"
        strokeWidth="3"
        transform="rotate(-180 28.5 28.5)"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5"
        d="M12.294 0L0 12.639 12.294 25.706"
        transform="translate(29.059 15.647)"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5"
        d="M12.294 0L0 12.639 12.294 25.706"
        transform="rotate(-180 14.53 20.676)"
      />
    </g>
  </svg>
)

export default CloseModalIcon
